import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';

const RESOURCE_LABELS = {
    '/cards': 'Карточка',
    '/projects': 'Проект',
    '/scripts': 'Скрипты',
    '/infra/queues': 'Очереди',
    '/bitrix/fields/lead': 'Поля CRM: лиды',
    '/bitrix/fields/deal': 'Поля CRM: сделки',
    '/bitrix/fields/contact': 'Поля CRM: контакты',
    '/bitrix/users': 'Сотрудники Bitrix',
    '/operators': 'Операторы',
    '/users': 'Пользователи',
    '/cabinets': 'Кабинеты',
    '/schedule': 'Расписание',
    '/reports': 'Отчёты',
};

const typeVerb = (type) => {
    if (type === 'UPDATE' || type === 'CREATE') return 'Сохраняем';
    if (type === 'DELETE') return 'Удаляем';
    return 'Загружаем';
};

export const resourceLabel = (resource) => {
    if (!resource) return 'данные';
    if (RESOURCE_LABELS[resource]) return RESOURCE_LABELS[resource];
    const match = Object.keys(RESOURCE_LABELS).find((key) => resource.indexOf(key) === 0);
    if (match) return RESOURCE_LABELS[match];
    return String(resource).replace(/^\//, '').replace(/\//g, ' · ') || 'данные';
};

export const pendingReads = (pending = []) => (
    pending.filter((item) => item && item.type !== 'UPDATE' && item.type !== 'CREATE' && item.type !== 'DELETE')
);

const FetchStub = ({ pending, title }) => {
    const items = pendingReads(pending);
    return (
        <div className="pc-loadstub">
            <div className="pc-loadstub__card">
                <CircularProgress size={22} thickness={4} sx={{ color: 'var(--accent)' }} />
                <div>
                    <b>{title || 'Получаем данные'}</b>
                    <span>
                        {items.length
                            ? items.map((item) => `${typeVerb(item.type)} ${resourceLabel(item.resource).toLowerCase()}`).join(' · ')
                            : 'Подождите, запрос ещё выполняется.'}
                    </span>
                    {items.length > 0 && (
                        <ul>
                            {items.map((item) => (
                                <li key={item.id}>{resourceLabel(item.resource)}</li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

const FetchBanner = ({ pending }) => {
    const items = pendingReads(pending);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!items.length) {
            setVisible(false);
            return undefined;
        }
        const timer = setTimeout(() => setVisible(true), 350);
        return () => clearTimeout(timer);
    }, [items.length]);

    if (!visible || !items.length) return null;

    return (
        <div className="pc-fetchbar" role="status">
            <CircularProgress size={14} thickness={5} sx={{ color: 'var(--accent)' }} />
            <div>
                <b>Загружаем данные</b>
                <span>{items.map((item) => resourceLabel(item.resource)).join(', ')}</span>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    pending: (state.fetch && state.fetch.pending) || [],
});

export const LoadingStub = connect(mapStateToProps)(FetchStub);
export default connect(mapStateToProps)(FetchBanner);
